import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import './DateInput.css';

export default function DateInput({ label, value, onChange, required, error, showTime = false, placeholder }) {
  const toDate = v => v ? new Date(v) : null;
  const [selected, setSelected] = useState(toDate(value));

  useEffect(() => setSelected(toDate(value)), [value]);

  const handleChange = date => {
    setSelected(date);
    if (!onChange) return;
    if (!date) return onChange('');
    if (showTime) {
      onChange(date.toISOString());
    } else {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      onChange(`${y}-${m}-${d}`);
    }
  };

  return (
    <div style={{ marginBottom: 10 }}>
      <label>
        {label}{required && <span style={{ color: 'red', marginLeft: 4 }}>*</span>}:
        <div style={{ marginTop: 6 }}>
          <DatePicker
            selected={selected}
            onChange={handleChange}
            dateFormat={showTime ? "dd/MM/yyyy HH:mm" : "dd/MM/yyyy"}
            placeholderText={placeholder || (showTime ? "dd/MM/yyyy HH:mm" : "dd/MM/yyyy")}
            showTimeSelect={showTime}
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
            scrollableYearDropdown
            yearDropdownItemNumber={15}
            className={`date-input ${error ? 'has-error' : ''}`}
            isClearable
            {...(showTime ? { timeIntervals: 15 } : {})}
          />
        </div>
      </label>
      {error && <div style={{ color: '#de350b', fontSize: 12, marginTop: 4 }}>{error}</div>}
    </div>
  );
}
